"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStepDefinitionLocationLinks = void 0;
var helpers_js_1 = require("./helpers.js");
function getStepDefinitionLocationLinks(gherkinSource, position, expressionLinks) {
    var e_1, _a;
    var stepRange = (0, helpers_js_1.getStepRange)(gherkinSource, position);
    if (!stepRange)
        return [];
    var locationLinks = [];
    try {
        for (var expressionLinks_1 = __values(expressionLinks), expressionLinks_1_1 = expressionLinks_1.next(); !expressionLinks_1_1.done; expressionLinks_1_1 = expressionLinks_1.next()) {
            var expressionLink = expressionLinks_1_1.value;
            if (expressionLink.expression.match(stepRange.stepText)) {
                var locationLink = __assign(__assign({}, expressionLink.locationLink), { originSelectionRange: stepRange.range });
                locationLinks.push(locationLink);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (expressionLinks_1_1 && !expressionLinks_1_1.done && (_a = expressionLinks_1.return)) _a.call(expressionLinks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return locationLinks;
}
exports.getStepDefinitionLocationLinks = getStepDefinitionLocationLinks;
//# sourceMappingURL=getStepDefinitionLocationLinks.js.map